import { render, staticRenderFns } from "./ImproveTextBlock.vue?vue&type=template&id=774fe8dd&scoped=true"
import script from "./ImproveTextBlock.vue?vue&type=script&lang=js"
export * from "./ImproveTextBlock.vue?vue&type=script&lang=js"
import style0 from "./ImproveTextBlock.vue?vue&type=style&index=0&id=774fe8dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774fe8dd",
  null
  
)

export default component.exports